import { Frequency, RepeatStrategy } from 'src/modules/contentList/types';
import { useCustomFrequencyDescription } from './useCustomFrequencyDescription';
import { useFrequencyDescription } from './useFrequencyDescription';
export const useRecurrenceDescription = (module) => {
    const { utcStartAt, recurrenceDescription: frequency, strategy, every = 0, repeatWeekConfig, repeatMonthConfig } = module.mentorshipConfig?.repeatConfig ?? {};
    const date = new Date(utcStartAt || Date.now());
    const { getFrequencyDescription } = useFrequencyDescription(date);
    const { getDailyDescription, getWeeklyDescription, getMonthlyDescription } = useCustomFrequencyDescription({ date, every, repeatWeekConfig, repeatMonthConfig });
    const strategyToDescriptionMap = {
        [RepeatStrategy.Daily]: getDailyDescription,
        [RepeatStrategy.Weekly]: getWeeklyDescription,
        [RepeatStrategy.Monthly]: getMonthlyDescription
    };
    if (frequency == Frequency.Custom) {
        return strategyToDescriptionMap[strategy]?.();
    }
    return frequency ? getFrequencyDescription(frequency) : '';
};
